export const DEFAULT_INACTIVE_PERIOD = 10*1000;
export const DEFAULT_BLOCKED_CLASS = "___";

export const SESSION_PLAYER_ID = "replayerAnchor";
export const SESSION_PLAYER_PADDING = 16;
export const SESSION_PLAYER_SPEEDS = [ 1, 2, 4, 8 ];